export function toInstagramEmbedUrl(permalink: string | null | undefined): string | null {
  if (!permalink) {
    return null
  }

  try {
    const parsed = new URL(permalink)
    if (!parsed.hostname.includes('instagram.com')) {
      return null
    }

    const pathname = parsed.pathname.replace(/\/+$/, '')
    if (!pathname) {
      return null
    }

    parsed.pathname = `${pathname}/embed`
    parsed.search = ''
    parsed.hash = ''
    return parsed.toString()
  } catch {
    return null
  }
}
